import { Component, EventEmitter, Input, Output } from '@angular/core';

export type TarjetaAccionEstado = 'idle' | 'activa' | 'configurada';

@Component({
  selector: 'app-tarjeta-accion-firmante',
  templateUrl: './tarjeta-accion-firmante.component.html',
  styleUrls: ['./tarjeta-accion-firmante.component.css'],
})
export class TarjetaAccionFirmanteComponent {
  @Input() etiqueta = '';
  @Input() icono = '#icon-signature';
  @Input() estado: TarjetaAccionEstado = 'idle';
  @Input() configurada = false;
  @Input() resumen = '';
  @Input() dragHabilitado = false;
  @Input() mostrarConfig = true;
  @Input() mostrarDrag = false;

  @Output() tarjetaClick = new EventEmitter<void>();
  @Output() configClick = new EventEmitter<void>();
  @Output() dragClick = new EventEmitter<void>();

  onTarjetaClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).closest('.tarjeta-accion__config, .tarjeta-accion__drag')) {
      return;
    }
    this.tarjetaClick.emit();
  }

  onConfigClick(event: MouseEvent): void {
    event.stopPropagation();
    this.configClick.emit();
  }

  onDragClick(event: MouseEvent): void {
    event.stopPropagation();
    if (this.dragHabilitado) {
      this.dragClick.emit();
    }
  }
}
